import api from "./configs/axiosConfig";
import { REQUEST_TIMEOUT } from "../constants/default_request";

export const BaseAPI = {
  call: async function (url, data, timeout = REQUEST_TIMEOUT) {
    const response = await api.request({
      url,
      method: "POST",
      data: JSON.stringify(data),
      timeout,
    });

    return response;
  },
  getPdf: async function (url, data) {
    const response = await api.request({
      url,
      method: "POST",
      data: JSON.stringify(data),
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    });

    return response;
  },
};
